import React, { useState, useEffect } from 'react';
import { useSettings } from '../../context/SettingsContext';
import './ContactsPage.css';

const ContactsPage = () => {
  const { t } = useSettings();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');
    
    // Имитация отправки (в будущем подключить к API)
    setTimeout(() => {
      setStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
      
      setTimeout(() => {
        setStatus('');
      }, 5000);
    }, 1500);
  };

  return (
    <div className="contacts-page">
      <div className="contacts-container">
        <div className="contacts-hero">
          <h1 className="contacts-title">{t('contactsTitle')}</h1>
          <p className="contacts-subtitle">
            {t('contactsSubtitle')}
          </p>
        </div>

        <div className="contacts-content">
          <div className="contacts-info">
            <div className="info-card">
              <div className="info-icon">📧</div>
              <h3>Email</h3>
              <p><a href="mailto:info@kyrgyzaid.kg">info@kyrgyzaid.kg</a></p>
              <p className="info-note">{t('generalQuestions')}</p>
            </div>

            <div className="info-card">
              <div className="info-icon">🔒</div>
              <h3>{t('privacyPolicy')}</h3>
              <p><a href="mailto:privacy@kyrgyzaid.kg">privacy@kyrgyzaid.kg</a></p>
              <p className="info-note">{t('privacyQuestions')}</p>
            </div>

            <div className="info-card">
              <div className="info-icon">📞</div>
              <h3>Телефон</h3>
              <p><a href="tel:+996xxxxxxxxx">+996 (xxx) xx-xx-xx</a></p>
              <p className="info-note">{t('contactPhoneNote')}</p>
            </div>

            <div className="info-card">
              <div className="info-icon">📍</div>
              <h3>Адрес</h3>
              <p>{t('contactAddress')}</p>
            </div>

            <div className="info-card">
              <div className="info-icon">💼</div>
              <h3>Сотрудничество</h3>
              <p><a href="mailto:partner@kyrgyzaid.kg">partner@kyrgyzaid.kg</a></p>
              <p className="info-note">{t('businessOffers')}</p>
            </div>

            <div className="info-card">
              <div className="info-icon">💰</div>
              <h3>{t('donations')}</h3>
              <p><a href="mailto:donate@kyrgyzaid.kg">donate@kyrgyzaid.kg</a></p>
              <p className="info-note">{t('donations')}</p>
            </div>
          </div>

          <div className="contact-form-section">
            <h2>{t('writeUsTitle')}</h2>
            <p className="form-description">
              {t('formDesc')}
            </p>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">{t('yourName')}</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder={t('yourName')}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your@email.com"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">{t('subject')}</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder={t('subject')}
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">{t('message')}</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  placeholder={t('message')}
                ></textarea>
              </div>

              {status === 'success' && (
                <div className="form-success">
                  ✓ {t('sendSuccess')}
                </div>
              )}

              <button 
                type="submit" 
                className="submit-button"
                disabled={status === 'sending'}
              >
                {status === 'sending' ? t('sending') : t('sendMessage')}
              </button>
            </form>
          </div>
        </div>

        <div className="faq-section">
          <h2>{t('faqTitle')}</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>Как зарегистрироваться?</h3>
              <p>Нажмите кнопку "Вход" в верхнем правом углу, затем выберите "Зарегистрироваться". Вам потребуется только email и имя.</p>
            </div>

            <div className="faq-item">
              <h3>Платформа бесплатная?</h3>
              <p>Да, все материалы библиотеки и новости полностью бесплатны для всех пользователей.</p>
            </div>

            <div className="faq-item">
              <h3>Как предложить книгу?</h3>
              <p>Напишите нам на info@kyrgyzaid.kg с указанием названия книги и автора. Мы рассмотрим ваше предложение.</p>
            </div>

            <div className="faq-item">
              <h3>Где посмотреть историю активности?</h3>
              <p>В личном профиле вы найдете историю прочитанных книг, ваши комментарии и лайки.</p>
            </div>

            <div className="faq-item">
              <h3>Как стать автором новостей?</h3>
              <p>Если вы журналист или специалист в какой-либо области, напишите на partner@kyrgyzaid.kg с примерами ваших работ.</p>
            </div>

            <div className="faq-item">
              <h3>Безопасны ли мои данные?</h3>
              <p>Да, мы используем современные методы защиты. Подробнее в <a href="/privacy-policy">Политике конфиденциальности</a>.</p>
            </div>
          </div>
        </div>

        <div className="social-section">
          <h2>{t('socialTitle')}</h2>
          <p>Следите за нашими новостями и обновлениями</p>
          <div className="social-links">
            <a href="#" className="social-link" aria-label="Facebook">
              <span className="social-icon">📘</span>
              <span>Facebook</span>
            </a>
            <a href="#" className="social-link" aria-label="Instagram">
              <span className="social-icon">📷</span>
              <span>Instagram</span>
            </a>
            <a href="#" className="social-link" aria-label="Telegram">
              <span className="social-icon">✈️</span>
              <span>Telegram</span>
            </a>
            <a href="#" className="social-link" aria-label="WhatsApp">
              <span className="social-icon">💬</span>
              <span>WhatsApp</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactsPage;
